import { makeVar } from '@apollo/client'

const otp = () => {
  return localStorage.getItem('otp')
}

export const otpVar = makeVar(otp())

export const currentOtp = {
  read() {
    return otpVar()
  },
}

const anonGroupId = () => {
  return localStorage.getItem('anonGroupId')
}

export const anonGroupIdVar = makeVar(anonGroupId())

export const currentAnonGroupId = {
  read() {
    return anonGroupIdVar()
  },
}

const isLoggedIn = () => {
  const token = localStorage.getItem('authToken')
  return !!token
}

const subdomain = () => {
  const subdomain = localStorage.getItem('subdomain')
  return subdomain
}

export const appSubdomainVar = makeVar(subdomain())

export const appSubdomain = {
  read() {
    return appSubdomainVar()
  },
}

export const isUserLoggedInVar = makeVar(isLoggedIn())

export const isUserLoggedIn = {
  read() {
    return isUserLoggedInVar()
  },
}
